/**
 * Represents holding types. 'Holdings' refers to T25 fund holdings and all holdings for other security types.
 */
export const HOLDINGS = 'holdings';
export const ALL_HOLDINGS = 'all-holdings';
export const FLATTENED_HOLDINGS = 'flattened-holdings';
export const HOLDINGS_TYPES = [HOLDINGS, ALL_HOLDINGS, FLATTENED_HOLDINGS];
/**
 * Represents comparable intersection types - all/common/unique
 */
export const INTERSECT_ALL_HOLDINGS = 'allHoldings';
export const INTERSECT_COMMON_HOLDINGS = 'commonHoldings';
export const INTERSECT_UNIQUE_HOLDINGS = 'uniqueHoldings';
/**
 * Represents the types of categories that we can divide holdings by
 */
export const BROAD_ASSET_CLASS = 'broad_asset_class';
export const CATEGORY_NAME = 'category_name';
export const EQUITY_STYLE = 'equity_style';
export const SECTOR = 'sector';
export const CATEGORY_TYPES = [BROAD_ASSET_CLASS, CATEGORY_NAME, EQUITY_STYLE, SECTOR];
/**
 * Holdings Table Dropdown Constants
 */
export const SAVE_AS_WATCHLIST_OPTION = 'save_as_watchlist';
export const EXPORT_HOLDINGS_OPTION = 'export_holdings_option';
export const EXPORT_LATEST_HOLDINGS_OPTION = 'export_latest_holdings_option';
export const REMOVE_COMPARABLE_OPTION = 'remove_comparable';
export const COMPARISON_TABLE_HEADER_DROPDOWN_CONFIG = {
    title: {
        label: '',
        icon: 'icon-dots-more',
    },
    list: [
        {
            icon: 'icon-save',
            type: 'option',
            label: 'Save as Watchlist',
            value: SAVE_AS_WATCHLIST_OPTION,
        },
        {
            icon: 'icon-csv',
            type: 'option',
            label: 'Export Holdings',
            value: EXPORT_HOLDINGS_OPTION,
        },
        {
            icon: 'icon-close',
            type: 'option',
            label: 'Remove Comparable',
            value: REMOVE_COMPARABLE_OPTION,
        },
    ],
};
export const HOLDINGS_HISTORY_TABLE_HEADER_DROPDOWN_CONFIG = {
    title: {
        label: '',
        icon: 'icon-dots-more',
    },
    list: [
        {
            icon: 'icon-save',
            type: 'option',
            label: 'Save as Watchlist',
            value: SAVE_AS_WATCHLIST_OPTION,
        },
        {
            icon: 'icon-csv',
            type: 'option',
            label: 'Export Holdings',
            value: EXPORT_HOLDINGS_OPTION,
        },
    ],
};
export const HOLDINGS_ALL_HOLDINGS_TABLE_HEADER_DROPDOWN_CONFIG = {
    title: {
        label: '',
        icon: 'icon-dots-more',
    },
    list: [
        {
            icon: 'icon-csv',
            type: 'option',
            label: 'Export Holdings',
            value: EXPORT_HOLDINGS_OPTION,
        },
        {
            icon: 'icon-csv',
            type: 'option',
            label: 'Export Holdings (Latest)',
            value: EXPORT_LATEST_HOLDINGS_OPTION,
        },
        {
            icon: 'icon-save',
            type: 'option',
            label: 'Save as Watchlist',
            value: SAVE_AS_WATCHLIST_OPTION,
        },
    ],
};
